import {IntlShape} from "react-intl";
import {ISelectOption} from "./components/Select/Select";
import {useMemo} from "react";

export const LanguageCodeMap = {
  en: 'E',
  fr: 'F',
  it: 'G',
  de: 'I',
}

// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const useAllCurrencyOptions = (intl: IntlShape) => useMemo((): ISelectOption[] => [
  intl.formatMessage({ defaultMessage: 'AED UAE dirham' }),
  intl.formatMessage({ defaultMessage: 'AFN afgan' }),
  intl.formatMessage({ defaultMessage: 'ALL lek' }),
  intl.formatMessage({ defaultMessage: 'AMD armenski dram' }),
  intl.formatMessage({ defaultMessage: 'ANG nizozemskoantilski gulden' }),
  intl.formatMessage({ defaultMessage: 'AOA kvanza' }),
  intl.formatMessage({ defaultMessage: 'ARS argentinski pezo ' }),
  intl.formatMessage({ defaultMessage: 'AUD australski dolar' }),
  intl.formatMessage({ defaultMessage: 'AWG arupski florin' }),
  intl.formatMessage({ defaultMessage: 'AZN azerbajdžanski manat ' }),
  intl.formatMessage({ defaultMessage: 'BAM konvertibilna marka' }),
  intl.formatMessage({ defaultMessage: 'BBD barbadoski dolar' }),
  intl.formatMessage({ defaultMessage: 'BDT taka ' }),
  intl.formatMessage({ defaultMessage: 'BGN bugarski lev' }),
  intl.formatMessage({ defaultMessage: 'BHD bahreinski dinar' }),
  intl.formatMessage({ defaultMessage: 'BIF burundski franak' }),
  intl.formatMessage({ defaultMessage: 'BMD bermudski dolar' }),
  intl.formatMessage({ defaultMessage: 'BND brunejski dolar' }),
  intl.formatMessage({ defaultMessage: 'BOB bolivijano' }),
  intl.formatMessage({ defaultMessage: 'BRL brazilski real' }),
  intl.formatMessage({ defaultMessage: 'BSD bahamski dolar' }),
  intl.formatMessage({ defaultMessage: 'BTN ngultrum' }),
  intl.formatMessage({ defaultMessage: 'BWP pula ' }),
  intl.formatMessage({ defaultMessage: 'BYN bjeloruski rubalj ' }),
  intl.formatMessage({ defaultMessage: 'BZD belizeanski dolar' }),
  intl.formatMessage({ defaultMessage: 'CAD kanadski dolar' }),
  intl.formatMessage({ defaultMessage: 'CDF kongoanski franak' }),
  intl.formatMessage({ defaultMessage: 'CHF švicarski franak' }),
  intl.formatMessage({ defaultMessage: 'CLP čileanski pezo' }),
  intl.formatMessage({ defaultMessage: 'CNY juan renminbi' }),
  intl.formatMessage({ defaultMessage: 'COP kolumbijski pezo' }),
  intl.formatMessage({ defaultMessage: 'CRC kostarikanski kolon' }),
  intl.formatMessage({ defaultMessage: 'CUP kubanski pezo' }),
  intl.formatMessage({ defaultMessage: 'CVE zelenortski eskudo' }),
  intl.formatMessage({ defaultMessage: 'CZK češka kruna' }),
  intl.formatMessage({ defaultMessage: 'DJF džibutski franak' }),
  intl.formatMessage({ defaultMessage: 'DKK danska kruna' }),
  intl.formatMessage({ defaultMessage: 'DOP dominikanski pezo' }),
  intl.formatMessage({ defaultMessage: 'DZD alžirski dinar' }),
  intl.formatMessage({ defaultMessage: 'EGP egipatska funta' }),
  intl.formatMessage({ defaultMessage: 'ETB etiopski bir' }),
  intl.formatMessage({ defaultMessage: 'EUR euro' }),
  intl.formatMessage({ defaultMessage: 'FJD fidžijski dolar' }),
  intl.formatMessage({ defaultMessage: 'FKP falklandska funta 3' }),
  intl.formatMessage({ defaultMessage: 'GBP funta sterlinga' }),
  intl.formatMessage({ defaultMessage: 'GEL lari' }),
  intl.formatMessage({ defaultMessage: 'GHS ganski cedi ' }),
  intl.formatMessage({ defaultMessage: 'GIP gibraltarska funta 1' }),
  intl.formatMessage({ defaultMessage: 'GMD dalasi' }),
  intl.formatMessage({ defaultMessage: 'GNF gvinejski franak' }),
  intl.formatMessage({ defaultMessage: 'GTQ kvecal' }),
  intl.formatMessage({ defaultMessage: 'GYD gvajanski dolar' }),
  intl.formatMessage({ defaultMessage: 'HKD hongkonški dolar' }),
  intl.formatMessage({ defaultMessage: 'HNL lempira' }),
  intl.formatMessage({ defaultMessage: 'HRK hrvatska kuna' }),
  intl.formatMessage({ defaultMessage: 'HTG gourd' }),
  intl.formatMessage({ defaultMessage: 'HUF forinta' }),
  intl.formatMessage({ defaultMessage: 'IDR rupija' }),
  intl.formatMessage({ defaultMessage: 'ILS novi izraelski šekel' }),
  intl.formatMessage({ defaultMessage: 'INR indijska rupija' }),
  intl.formatMessage({ defaultMessage: 'IQD irački dinar' }),
  intl.formatMessage({ defaultMessage: 'IRR iranski rijal 2' }),
  intl.formatMessage({ defaultMessage: 'ISK islandska kruna' }),
  intl.formatMessage({ defaultMessage: 'JMD jamajčanski dolar' }),
  intl.formatMessage({ defaultMessage: 'JOD jordanski dinar' }),
  intl.formatMessage({ defaultMessage: 'JPY jen' }),
  intl.formatMessage({ defaultMessage: 'KES kenijski šiling' }),
  intl.formatMessage({ defaultMessage: 'KGS som' }),
  intl.formatMessage({ defaultMessage: 'KHR rijal' }),
  intl.formatMessage({ defaultMessage: 'KMF komorski franak' }),
  intl.formatMessage({ defaultMessage: 'KRW von' }),
  intl.formatMessage({ defaultMessage: 'KWD kuvajtski dinar' }),
  intl.formatMessage({ defaultMessage: 'KYD kajmanski dolar' }),
  intl.formatMessage({ defaultMessage: 'KZT tenge' }),
  intl.formatMessage({ defaultMessage: 'LAK lao kip' }),
  intl.formatMessage({ defaultMessage: 'LBP libanonska funta' }),
  intl.formatMessage({ defaultMessage: 'LKR šrilanska rupija' }),
  intl.formatMessage({ defaultMessage: 'LRD liberijski dolar 4' }),
  intl.formatMessage({ defaultMessage: 'LSL loti' }),
  intl.formatMessage({ defaultMessage: 'LYD libijski dinar' }),
  intl.formatMessage({ defaultMessage: 'MAD marokanski dirham' }),
  intl.formatMessage({ defaultMessage: 'MDL moldavski lej' }),
  intl.formatMessage({ defaultMessage: 'MGA malgaški arijari ' }),
  intl.formatMessage({ defaultMessage: 'MKD sjeverno makedonski denar' }),
  intl.formatMessage({ defaultMessage: 'MMK kjat' }),
  intl.formatMessage({ defaultMessage: 'MNT tugrik' }),
  intl.formatMessage({ defaultMessage: 'MOP pataka' }),
  intl.formatMessage({ defaultMessage: 'MRU ouguja' }),
  intl.formatMessage({ defaultMessage: 'MUR mauricijska rupija' }),
  intl.formatMessage({ defaultMessage: 'MVR rufija ' }),
  intl.formatMessage({ defaultMessage: 'MWK malavi kvača' }),
  intl.formatMessage({ defaultMessage: 'MXN meksički pezo' }),
  intl.formatMessage({ defaultMessage: 'MYR malezijski ringit ' }),
  intl.formatMessage({ defaultMessage: 'MZN mozambijski metikal ' }),
  intl.formatMessage({ defaultMessage: 'NAD namibijski dolar ' }),
  intl.formatMessage({ defaultMessage: 'NGN naira' }),
  intl.formatMessage({ defaultMessage: 'NIO kordoba oro' }),
  intl.formatMessage({ defaultMessage: 'NOK norveška kruna' }),
  intl.formatMessage({ defaultMessage: 'NPR nepalska rupija' }),
  intl.formatMessage({ defaultMessage: 'NZD novozelandski dolar' }),
  intl.formatMessage({ defaultMessage: 'OMR omanski rijal' }),
  intl.formatMessage({ defaultMessage: 'PAB balboa' }),
  intl.formatMessage({ defaultMessage: 'PEN sol' }),
  intl.formatMessage({ defaultMessage: 'PGK kina' }),
  intl.formatMessage({ defaultMessage: 'PHP filipinski pezo' }),
  intl.formatMessage({ defaultMessage: 'PKR pakistanska rupija' }),
  intl.formatMessage({ defaultMessage: 'PLN zloti' }),
  intl.formatMessage({ defaultMessage: 'PYG gvarani' }),
  intl.formatMessage({ defaultMessage: 'QAR katarski rijal' }),
  intl.formatMessage({ defaultMessage: 'RON rumunjski leu ' }),
  intl.formatMessage({ defaultMessage: 'RSD srpski dinar' }),
  intl.formatMessage({ defaultMessage: 'RUB ruski rubalj' }),
  intl.formatMessage({ defaultMessage: 'RWF ruandski franak' }),
  intl.formatMessage({ defaultMessage: 'SAR saudijski rijal' }),
  intl.formatMessage({ defaultMessage: 'SBD solomonskootočni dolar' }),
  intl.formatMessage({ defaultMessage: 'SCR sejšelska rupija' }),
  intl.formatMessage({ defaultMessage: 'SDG sudanska funta 5 ' }),
  intl.formatMessage({ defaultMessage: 'SEK švedska kruna' }),
  intl.formatMessage({ defaultMessage: 'SGD singapurski dolar' }),
  intl.formatMessage({ defaultMessage: 'SLL leone ' }),
  intl.formatMessage({ defaultMessage: 'SOS somalijski šiling' }),
  intl.formatMessage({ defaultMessage: 'SRD surinamski dolar' }),
  intl.formatMessage({ defaultMessage: 'STN dobra' }),
  intl.formatMessage({ defaultMessage: 'SVC salvadorski kolon' }),
  intl.formatMessage({ defaultMessage: 'SZL lilangeni' }),
  intl.formatMessage({ defaultMessage: 'THB baht' }),
  intl.formatMessage({ defaultMessage: 'TND tuniski dinar' }),
  intl.formatMessage({ defaultMessage: "TOP pa/'anga" }),
  intl.formatMessage({ defaultMessage: 'TRY turska lira ' }),
  intl.formatMessage({ defaultMessage: 'TTD trinidadtobaški dolar' }),
  intl.formatMessage({ defaultMessage: 'TWD novotajvanski dolar' }),
  intl.formatMessage({ defaultMessage: 'TZS tanzanijski šiling' }),
  intl.formatMessage({ defaultMessage: 'UAH hrivnja' }),
  intl.formatMessage({ defaultMessage: 'UGX ugandski šiling' }),
  intl.formatMessage({ defaultMessage: 'USD američki dolar' }),
  intl.formatMessage({ defaultMessage: 'UYU urugvajski pezo' }),
  intl.formatMessage({ defaultMessage: 'UZS uzbekistanski sum' }),
  intl.formatMessage({ defaultMessage: 'VES bolivarski soberano' }),
  intl.formatMessage({ defaultMessage: 'VND dong' }),
  intl.formatMessage({ defaultMessage: 'VUV vatu' }),
  intl.formatMessage({ defaultMessage: 'WST tala' }),
  intl.formatMessage({ defaultMessage: 'XAF CFA franak BEAC' }),
  intl.formatMessage({ defaultMessage: 'XCD istočnokaripski dolar' }),
  intl.formatMessage({ defaultMessage: 'XOF CFA franak BCEAO' }),
  intl.formatMessage({ defaultMessage: 'XPF CFP franak' }),
  intl.formatMessage({ defaultMessage: 'YER jemenski rijal' }),
  intl.formatMessage({ defaultMessage: 'ZAR rand' }),
  intl.formatMessage({ defaultMessage: 'ZMW zambijska kvača' })  
].map((currency) => ({ value: currency, label: currency })), [intl])
export const countries = [
  { label: 'Australija', value: 'AU' },
  { label: 'Austrija', value: 'AT' },
  { label: 'Bosna i Hercegovina', value: 'BA' },
  { label: 'Belgija', value: 'BE' },
  { label: 'Bugarska', value: 'BG' },
  { label: 'Cipar', value: 'CY' },
  { label: 'Crna Gora', value: 'MN' },
  { label: 'Češka', value: 'CZ' },
  { label: 'Kanada', value: 'CA' },
  { label: 'Njemačka', value: 'DE' },
  { label: 'Danska', value: 'DK' },
  { label: 'Estonija', value: 'EE' },
  { label: 'Finska', value: 'FI' },
  { label: 'Francuska', value: 'FR' },
  { label: 'Grčka', value: 'EL' },
  { label: 'Irska', value: 'IE' },
  { label: 'Island', value: 'IS' },
  { label: 'Italija', value: 'IT' },
  { label: 'Južna Koreja', value: 'KR' },
  { label: 'Latvija', value: 'LV' },
  { label: 'Lihteštajn', value: 'LI' },
  { label: 'Litva', value: 'LT' },
  { label: 'Luksemburg', value: 'LU' },
  { label: 'Mađarska', value: 'HU' },
  { label: 'Malta', value: 'MT' },
  { label: 'Nizozemska', value: 'NL' },
  { label: 'Norveška', value: 'NO' },
  { label: 'Poljska', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Rumunjska', value: 'RO' },
  { label: 'Sjeverna Makedonija', value: 'MK' },
  { label: 'Slovačka', value: 'SK' },
  { label: 'Slovenija', value: 'SI' },
  { label: 'Srbija', value: 'RS' },
  { label: 'Španjolska', value: 'ES' },
  { label: 'Švedska', value: 'SE' },
  { label: 'Švicarska', value: 'CH' },
  { label: 'Turska', value: 'TR' },
  { label: 'Ujedinjeno Kraljevstvo ', value: 'GB' },
  { label: 'Kosovo', value: 'XK' },
]

export const currencies = [
  { label: 'euro', value: 'EUR' },
  { label: 'australski dolar', value: 'AUD' },
  { label: 'kanadski dolar', value: 'CAD' },
  { label: 'švicarski franak', value: 'CHF' },
  { label: 'češka kruna', value: 'CZK' },
  { label: 'danska kruna', value: 'DKK' },
  { label: 'britanska funta', value: 'GBP' },
  { label: 'mađarska forinta', value: 'HUF' },
  { label: 'poljski zlot', value: 'PLN' },
  { label: 'norveška kruna', value: 'NOK' },
  { label: 'švedska kruna', value: 'SEK' },
  { label: 'konvertibilna marka', value: 'BAM' },
  { label: 'srpski dinar', value: 'RSD' },
  { label: 'sjeverno makedonski denar', value: 'MKD' },
  { label: 'turska lira ', value: 'TRY' },
  { label: 'korejski won', value: 'KRW' },
  { label: 'bugarski lev', value: 'BGN' },
  { label: 'islandska kruna', value: 'ISK' },
  { label: 'rumunjski leu ', value: 'RON' }
]

export const useAllCountriesOptions = (intl: IntlShape) => useMemo((): ISelectOption[] => [
  intl.formatMessage({ defaultMessage: 'Afghanistan' }),
  intl.formatMessage({ defaultMessage: 'Åland' }),
  intl.formatMessage({ defaultMessage: 'Albania' }),
  intl.formatMessage({ defaultMessage: 'Algeria' }),
  intl.formatMessage({ defaultMessage: 'American' }),
  intl.formatMessage({ defaultMessage: 'Andorra' }),
  intl.formatMessage({ defaultMessage: 'Angola' }),
  intl.formatMessage({ defaultMessage: 'Anguilla' }),
  intl.formatMessage({ defaultMessage: 'Antarctica' }),
  intl.formatMessage({ defaultMessage: 'Antigua' }),
  intl.formatMessage({ defaultMessage: 'Argentina' }),
  intl.formatMessage({ defaultMessage: 'Armenia' }),
  intl.formatMessage({ defaultMessage: 'Aruba' }),
  intl.formatMessage({ defaultMessage: 'Australia' }),
  intl.formatMessage({ defaultMessage: 'Austria' }),
  intl.formatMessage({ defaultMessage: 'Azerbaijan' }),
  intl.formatMessage({ defaultMessage: 'Bahamas' }),
  intl.formatMessage({ defaultMessage: 'Bahrain' }),
  intl.formatMessage({ defaultMessage: 'Bangladesh' }),
  intl.formatMessage({ defaultMessage: 'Barbados' }),
  intl.formatMessage({ defaultMessage: 'Belarus' }),
  intl.formatMessage({ defaultMessage: 'Belgium' }),
  intl.formatMessage({ defaultMessage: 'Belize' }),
  intl.formatMessage({ defaultMessage: 'Benin' }),
  intl.formatMessage({ defaultMessage: 'Bermuda' }),
  intl.formatMessage({ defaultMessage: 'Bhutan' }),
  intl.formatMessage({ defaultMessage: 'Bolivia, Plurinational State of' }),
  intl.formatMessage({ defaultMessage: 'Bonaire, Sint Eustatius and Saba' }),
  intl.formatMessage({ defaultMessage: 'Bosnia and Herzegovina' }),
  intl.formatMessage({ defaultMessage: 'Botswana' }),
  intl.formatMessage({ defaultMessage: 'Bouvet Island' }),
  intl.formatMessage({ defaultMessage: 'Brazil' }),
  intl.formatMessage({ defaultMessage: 'British Indian Ocean Territory' }),
  intl.formatMessage({ defaultMessage: 'Brunei Darussalam' }),
  intl.formatMessage({ defaultMessage: 'Bulgaria' }),
  intl.formatMessage({ defaultMessage: 'Burkina Faso' }),
  intl.formatMessage({ defaultMessage: 'Burundi' }),
  intl.formatMessage({ defaultMessage: 'Cambodia' }),
  intl.formatMessage({ defaultMessage: 'Cameroon' }),
  intl.formatMessage({ defaultMessage: 'Canada' }),
  intl.formatMessage({ defaultMessage: 'Cape Verde' }),
  intl.formatMessage({ defaultMessage: 'Cayman Islands' }),
  intl.formatMessage({ defaultMessage: 'Central African Republic' }),
  intl.formatMessage({ defaultMessage: 'Chad' }),
  intl.formatMessage({ defaultMessage: 'Chile' }),
  intl.formatMessage({ defaultMessage: 'China' }),
  intl.formatMessage({ defaultMessage: 'Christmas Island' }),
  intl.formatMessage({ defaultMessage: 'Cocos (Keeling) Islands' }),
  intl.formatMessage({ defaultMessage: 'Colombia' }),
  intl.formatMessage({ defaultMessage: 'Comoros' }),
  intl.formatMessage({ defaultMessage: 'Congo' }),
  intl.formatMessage({ defaultMessage: 'Congo, the Democratic Republic of the' }),
  intl.formatMessage({ defaultMessage: 'Cook Islands' }),
  intl.formatMessage({ defaultMessage: 'Costa Rica' }),
  intl.formatMessage({ defaultMessage: 'Côte d\'Ivoire' }),
  intl.formatMessage({ defaultMessage: 'Croatia' }),
  intl.formatMessage({ defaultMessage: 'Cuba' }),
  intl.formatMessage({ defaultMessage: 'Curaçao' }),
  intl.formatMessage({ defaultMessage: 'Cyprus' }),
  intl.formatMessage({ defaultMessage: 'Czech Republic' }),
  intl.formatMessage({ defaultMessage: 'Denmark' }),
  intl.formatMessage({ defaultMessage: 'Djibouti' }),
  intl.formatMessage({ defaultMessage: 'Dominica' }),
  intl.formatMessage({ defaultMessage: 'Dominican Republic' }),
  intl.formatMessage({ defaultMessage: 'Ecuador' }),
  intl.formatMessage({ defaultMessage: 'Egypt' }),
  intl.formatMessage({ defaultMessage: 'El Salvador' }),
  intl.formatMessage({ defaultMessage: 'Equatorial Guinea' }),
  intl.formatMessage({ defaultMessage: 'Eritrea' }),
  intl.formatMessage({ defaultMessage: 'Estonia' }),
  intl.formatMessage({ defaultMessage: 'Ethiopia' }),
  intl.formatMessage({ defaultMessage: 'Falkland Islands (Malvinas)' }),
  intl.formatMessage({ defaultMessage: 'Faroe Islands' }),
  intl.formatMessage({ defaultMessage: 'Fiji' }),
  intl.formatMessage({ defaultMessage: 'Finland' }),
  intl.formatMessage({ defaultMessage: 'France' }),
  intl.formatMessage({ defaultMessage: 'French Guiana' }),
  intl.formatMessage({ defaultMessage: 'French Polynesia' }),
  intl.formatMessage({ defaultMessage: 'French Southern Territories' }),
  intl.formatMessage({ defaultMessage: 'Gabon' }),
  intl.formatMessage({ defaultMessage: 'Gambia' }),
  intl.formatMessage({ defaultMessage: 'Georgia' }),
  intl.formatMessage({ defaultMessage: 'Germany' }),
  intl.formatMessage({ defaultMessage: 'Ghana' }),
  intl.formatMessage({ defaultMessage: 'Gibraltar' }),
  intl.formatMessage({ defaultMessage: 'Greece' }),
  intl.formatMessage({ defaultMessage: 'Greenland' }),
  intl.formatMessage({ defaultMessage: 'Grenada' }),
  intl.formatMessage({ defaultMessage: 'Guadeloupe' }),
  intl.formatMessage({ defaultMessage: 'Guam' }),
  intl.formatMessage({ defaultMessage: 'Guatemala' }),
  intl.formatMessage({ defaultMessage: 'Guernsey' }),
  intl.formatMessage({ defaultMessage: 'Guinea' }),
  intl.formatMessage({ defaultMessage: 'Guinea-Bissau' }),
  intl.formatMessage({ defaultMessage: 'Guyana' }),
  intl.formatMessage({ defaultMessage: 'Haiti' }),
  intl.formatMessage({ defaultMessage: 'Heard Island and McDonald Islands' }),
  intl.formatMessage({ defaultMessage: 'Holy See (Vatican City State)' }),
  intl.formatMessage({ defaultMessage: 'Honduras' }),
  intl.formatMessage({ defaultMessage: 'Hong Kong' }),
  intl.formatMessage({ defaultMessage: 'Hungary' }),
  intl.formatMessage({ defaultMessage: 'Iceland' }),
  intl.formatMessage({ defaultMessage: 'India' }),
  intl.formatMessage({ defaultMessage: 'Indonesia' }),
  intl.formatMessage({ defaultMessage: 'Iran, Islamic Republic of' }),
  intl.formatMessage({ defaultMessage: 'Iraq' }),
  intl.formatMessage({ defaultMessage: 'Ireland,' }),
  intl.formatMessage({ defaultMessage: 'Isle of Man' }),
  intl.formatMessage({ defaultMessage: 'Israel' }),
  intl.formatMessage({ defaultMessage: 'Italy' }),
  intl.formatMessage({ defaultMessage: 'Jamaica' }),
  intl.formatMessage({ defaultMessage: 'Japan' }),
  intl.formatMessage({ defaultMessage: 'Jersey' }),
  intl.formatMessage({ defaultMessage: 'Jordan' }),
  intl.formatMessage({ defaultMessage: 'Kazakhstan' }),
  intl.formatMessage({ defaultMessage: 'Kenya' }),
  intl.formatMessage({ defaultMessage: 'Kiribati' }),
  intl.formatMessage({ defaultMessage: 'Korea, Democratic People\'s Republic of' }),
  intl.formatMessage({ defaultMessage: 'Korea, Republic of' }),
  intl.formatMessage({ defaultMessage: 'Kuwait' }),
  intl.formatMessage({ defaultMessage: 'Kyrgyzstan' }),
  intl.formatMessage({ defaultMessage: 'Lao People\'s Democratic Republic' }),
  intl.formatMessage({ defaultMessage: 'Latvia' }),
  intl.formatMessage({ defaultMessage: 'Lebanon' }),
  intl.formatMessage({ defaultMessage: 'Lesotho' }),
  intl.formatMessage({ defaultMessage: 'Liberia' }),
  intl.formatMessage({ defaultMessage: 'Libya' }),
  intl.formatMessage({ defaultMessage: 'Liechtenstein' }),
  intl.formatMessage({ defaultMessage: 'Lithuania' }),
  intl.formatMessage({ defaultMessage: 'Luxembourg' }),
  intl.formatMessage({ defaultMessage: 'Macao' }),
  intl.formatMessage({ defaultMessage: 'Macedonia, the Former Yugoslav Republic of' }),
  intl.formatMessage({ defaultMessage: 'Madagascar' }),
  intl.formatMessage({ defaultMessage: 'Malawi' }),
  intl.formatMessage({ defaultMessage: 'Malaysia' }),
  intl.formatMessage({ defaultMessage: 'Maldives' }),
  intl.formatMessage({ defaultMessage: 'Mali' }),
  intl.formatMessage({ defaultMessage: 'Malta' }),
  intl.formatMessage({ defaultMessage: 'Marshall Islands' }),
  intl.formatMessage({ defaultMessage: 'Martinique' }),
  intl.formatMessage({ defaultMessage: 'Mauritania' }),
  intl.formatMessage({ defaultMessage: 'Mauritius' }),
  intl.formatMessage({ defaultMessage: 'Mayotte' }),
  intl.formatMessage({ defaultMessage: 'Mexico' }),
  intl.formatMessage({ defaultMessage: 'Micronesia, Federated States of' }),
  intl.formatMessage({ defaultMessage: 'Moldova, Republic of' }),
  intl.formatMessage({ defaultMessage: 'Monaco' }),
  intl.formatMessage({ defaultMessage: 'Mongolia' }),
  intl.formatMessage({ defaultMessage: 'Montenegro' }),
  intl.formatMessage({ defaultMessage: 'Montserrat' }),
  intl.formatMessage({ defaultMessage: 'Morocco' }),
  intl.formatMessage({ defaultMessage: 'Mozambique' }),
  intl.formatMessage({ defaultMessage: 'Myanmar' }),
  intl.formatMessage({ defaultMessage: 'Namibia' }),
  intl.formatMessage({ defaultMessage: 'Nauru' }),
  intl.formatMessage({ defaultMessage: 'Nepal' }),
  intl.formatMessage({ defaultMessage: 'Netherlands' }),
  intl.formatMessage({ defaultMessage: 'New Caledonia' }),
  intl.formatMessage({ defaultMessage: 'New Zealand' }),
  intl.formatMessage({ defaultMessage: 'Nicaragua' }),
  intl.formatMessage({ defaultMessage: 'Niger' }),
  intl.formatMessage({ defaultMessage: 'Nigeria' }),
  intl.formatMessage({ defaultMessage: 'Niue' }),
  intl.formatMessage({ defaultMessage: 'Norfolk Island' }),
  intl.formatMessage({ defaultMessage: 'Northern Mariana Islands' }),
  intl.formatMessage({ defaultMessage: 'Norway' }),
  intl.formatMessage({ defaultMessage: 'Oman' }),
  intl.formatMessage({ defaultMessage: 'Pakistan' }),
  intl.formatMessage({ defaultMessage: 'Palau' }),
  intl.formatMessage({ defaultMessage: 'Palestine' }),
  intl.formatMessage({ defaultMessage: 'Panama' }),
  intl.formatMessage({ defaultMessage: 'Papua New Guinea' }),
  intl.formatMessage({ defaultMessage: 'Paraguay' }),
  intl.formatMessage({ defaultMessage: 'Peru' }),
  intl.formatMessage({ defaultMessage: 'Philippines' }),
  intl.formatMessage({ defaultMessage: 'Pitcairn' }),
  intl.formatMessage({ defaultMessage: 'Poland' }),
  intl.formatMessage({ defaultMessage: 'Portugal' }),
  intl.formatMessage({ defaultMessage: 'Puerto Rico' }),
  intl.formatMessage({ defaultMessage: 'Qatar' }),
  intl.formatMessage({ defaultMessage: 'Réunion' }),
  intl.formatMessage({ defaultMessage: 'Romania' }),
  intl.formatMessage({ defaultMessage: 'Russian Federation' }),
  intl.formatMessage({ defaultMessage: 'Rwanda' }),
  intl.formatMessage({ defaultMessage: 'Saint Barthélemy' }),
  intl.formatMessage({ defaultMessage: 'Saint Helena, Ascension and Tristan da Cunha' }),
  intl.formatMessage({ defaultMessage: 'Saint Kitts and Nevis' }),
  intl.formatMessage({ defaultMessage: 'Saint Lucia' }),
  intl.formatMessage({ defaultMessage: 'Saint Martin (French part)' }),
  intl.formatMessage({ defaultMessage: 'Saint Pierre and Miquelon' }),
  intl.formatMessage({ defaultMessage: 'Saint Vincent and the Grenadines' }),
  intl.formatMessage({ defaultMessage: 'Samoa' }),
  intl.formatMessage({ defaultMessage: 'San Marino' }),
  intl.formatMessage({ defaultMessage: 'Sao Tome and Principe' }),
  intl.formatMessage({ defaultMessage: 'Saudi Arabia' }),
  intl.formatMessage({ defaultMessage: 'Senegal' }),
  intl.formatMessage({ defaultMessage: 'Serbia' }),
  intl.formatMessage({ defaultMessage: 'Seychelles' }),
  intl.formatMessage({ defaultMessage: 'Sierra Leone' }),
  intl.formatMessage({ defaultMessage: 'Singapore' }),
  intl.formatMessage({ defaultMessage: 'Sint Maarten (Dutch part)' }),
  intl.formatMessage({ defaultMessage: 'Slovakia' }),
  intl.formatMessage({ defaultMessage: 'Slovenia' }),
  intl.formatMessage({ defaultMessage: 'Solomon Islands' }),
  intl.formatMessage({ defaultMessage: 'Somalia' }),
  intl.formatMessage({ defaultMessage: 'South Africa' }),
  intl.formatMessage({ defaultMessage: 'South Georgia and the South Sandwich Islands' }),
  intl.formatMessage({ defaultMessage: 'South Sudan' }),
  intl.formatMessage({ defaultMessage: 'Spain' }),
  intl.formatMessage({ defaultMessage: 'Sri Lanka' }),
  intl.formatMessage({ defaultMessage: 'Sudan' }),
  intl.formatMessage({ defaultMessage: 'Suriname' }),
  intl.formatMessage({ defaultMessage: 'Svalbard and Jan Mayen' }),
  intl.formatMessage({ defaultMessage: 'Swaziland' }),
  intl.formatMessage({ defaultMessage: 'Sweden' }),
  intl.formatMessage({ defaultMessage: 'Switzerland' }),
  intl.formatMessage({ defaultMessage: 'Syrian Arab Republic' }),
  intl.formatMessage({ defaultMessage: 'Taiwan, Province of China' }),
  intl.formatMessage({ defaultMessage: 'Tajikistan' }),
  intl.formatMessage({ defaultMessage: 'Tanzania, United Republic of' }),
  intl.formatMessage({ defaultMessage: 'Thailand' }),
  intl.formatMessage({ defaultMessage: 'Timor-Leste' }),
  intl.formatMessage({ defaultMessage: 'Togo' }),
  intl.formatMessage({ defaultMessage: 'Tokelau' }),
  intl.formatMessage({ defaultMessage: 'Tonga' }),
  intl.formatMessage({ defaultMessage: 'Trinidad and Tobago' }),
  intl.formatMessage({ defaultMessage: 'Tunisia' }),
  intl.formatMessage({ defaultMessage: 'Turkey' }),
  intl.formatMessage({ defaultMessage: 'Turkmenistan' }),
  intl.formatMessage({ defaultMessage: 'Turks and Caicos Islands' }),
  intl.formatMessage({ defaultMessage: 'Tuvalu' }),
  intl.formatMessage({ defaultMessage: 'Uganda' }),
  intl.formatMessage({ defaultMessage: 'Ukraine' }),
  intl.formatMessage({ defaultMessage: 'United Arab Emirates' }),
  intl.formatMessage({ defaultMessage: 'United Kingdom' }),
  intl.formatMessage({ defaultMessage: 'United States' }),
  intl.formatMessage({ defaultMessage: 'United States Minor Outlying Islands' }),
  intl.formatMessage({ defaultMessage: 'Uruguay' }),
  intl.formatMessage({ defaultMessage: 'Uzbekistan' }),
  intl.formatMessage({ defaultMessage: 'Vanuatu' }),
  intl.formatMessage({ defaultMessage: 'Venezuela, Bolivarian Republic of' }),
  intl.formatMessage({ defaultMessage: 'Viet Nam' }),
  intl.formatMessage({ defaultMessage: 'Virgin Islands, British' }),
  intl.formatMessage({ defaultMessage: 'Virgin Islands, U.S.' }),
  intl.formatMessage({ defaultMessage: 'Wallis and Futuna' }),
  intl.formatMessage({ defaultMessage: 'Western Sahara' }),
  intl.formatMessage({ defaultMessage: 'Yemen' }),
  intl.formatMessage({ defaultMessage: 'Zambia' }),
  intl.formatMessage({ defaultMessage: 'Zimbabwe' }),
].map((country) => ({ value: country, label: country })), [intl])
